import { createApp } from 'vue';
import M4bToWavConverter from '@/Components/M4bToWavConverter.vue';
import '@styles/app.css';

createApp(M4bToWavConverter).mount('#m4b-to-wav-converter');
